import { render, staticRenderFns } from "./my_qa.vue?vue&type=template&id=234bde16&scoped=true"
import script from "./my_qa.vue?vue&type=script&lang=js"
export * from "./my_qa.vue?vue&type=script&lang=js"
import style0 from "./my_qa.vue?vue&type=style&index=0&id=234bde16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234bde16",
  null
  
)

export default component.exports